
(() => {
  const instances = new Map();
  const restored = new WeakSet();
  const cacheKey = 'spg-browse-v4';
  class CollectionPagination {
    constructor(root) {
      this.root = root;
      this.dataset = root.dataset;
      this.querySelector = root.querySelector.bind(root);
      this.addEventListener = root.addEventListener.bind(root);
      this.grid = root.closest('.collection-grid');
      if (!this.grid) return;
      this.controller = new AbortController();
      this.link = this.querySelector('[data-spg-browse-more]');
      this.status = this.querySelector('[data-spg-load-status]');
      this.label = this.link?.textContent;
      this.url = location.pathname + location.search;
      this.addEventListener('click', event => {
        const link = event.target.closest('[data-spg-browse-more]');
        if (!link || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
        event.preventDefault();
        this.load(matchMedia('(min-width: 769px)').matches ? 2 : 1, true);
      }, {signal: this.controller.signal});
      this.grid.addEventListener('click', event => {
        if (event.target.closest('a[href*="/products/"]')) this.save();
      }, {capture: true, signal: this.controller.signal});
      window.addEventListener('pagehide', () => this.save(), {signal: this.controller.signal});
      try {
        if (!history.state?.spgBrowseId) history.replaceState({...history.state, spgBrowseId: crypto.randomUUID()}, '', location.href);
        this.entry = history.state.spgBrowseId;
      } catch (_) {}
      this.updateCount();
      if (restored.has(this.root)) { restored.delete(this.root); return; }
      if (this.restore()) return;
      if (Number(this.dataset.page) === 1 && this.cards().length === 24 && matchMedia('(min-width: 769px)').matches) this.load(1, false);
    }
    get isConnected() { return this.root.isConnected; }
    disconnect() {
      this.controller?.abort();
      this.request?.abort();
    }
    cards() {
      return Array.from(this.grid.children).filter(node => node !== this.root);
    }
    updateCount() {
      this.status.textContent = this.dataset.countTemplate.replace('__COUNT__', this.cards().length);
    }
    save() {
      if (!this.entry || !this.isConnected || this.busy || this.url !== location.pathname + location.search) return;
      try {
        let entries = JSON.parse(sessionStorage.getItem(cacheKey) || '[]');
        entries = entries.filter(item => item.id !== this.entry && Date.now() - item.time < 1800000).slice(-3);
        const html = this.grid.innerHTML;
        if (html.length > 2000000) return;
        entries.push({id: this.entry, url: this.url, theme: this.dataset.theme, html, y: scrollY, time: Date.now()});
        sessionStorage.setItem(cacheKey, JSON.stringify(entries));
      } catch (_) {}
    }
    restore() {
      try {
        const entries = JSON.parse(sessionStorage.getItem(cacheKey) || '[]');
        const saved = entries.find(item => item.id === this.entry && item.url === this.url && item.theme === this.dataset.theme && Date.now() - item.time < 1800000);
        if (!saved) return false;
        const grid = this.grid;
        const fragment = document.createElement('template');
        fragment.innerHTML = saved.html;
        const pagination = fragment.content.querySelector('[data-spg-pagination]');
        if (!pagination) return false;
        restored.add(pagination);
        grid.replaceChildren(fragment.content);
        requestAnimationFrame(() => requestAnimationFrame(() => window.scrollTo({top: saved.y, behavior: 'instant'})));
        return true;
      } catch (_) { return false; }
    }
    async load(pages, focus) {
      if (this.busy || !this.link) return;
      this.busy = true;
      this.link.setAttribute('aria-disabled', 'true');
      this.link.textContent = this.dataset.loading;
      this.grid.setAttribute('aria-busy', 'true');
      this.request = new AbortController();
      let firstNew;
      let error = false;
      try {
        for (let page = 0; page < pages && this.link; page++) {
          const url = new URL(this.link.href, location.origin);
          if (url.origin !== location.origin) throw new Error('origin');
          url.searchParams.set('section_id', this.dataset.sectionId);
          const response = await fetch(url.toString(), {signal: AbortSignal.any([this.request.signal, AbortSignal.timeout(15000)])});
          if (!response.ok) throw new Error('load');
          const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
          const pagination = doc.querySelector('[data-spg-pagination]');
          const incoming = pagination?.closest('.collection-grid');
          if (!incoming || !pagination) throw new Error('markup');
          if (!this.isConnected || this.url !== location.pathname + location.search) return;
          const items = Array.from(incoming.children).filter(node => node !== pagination);
          if (!items.length) throw new Error('empty');
          firstNew ||= items[0];
          items.forEach(item => this.grid.insertBefore(item, this.root));
          this.dataset.page = pagination.dataset.page;
          const next = pagination.querySelector('[data-spg-browse-more]');
          if (next) this.link.href = next.href;
          else { this.link.remove(); this.link = null; }
          const details = this.querySelector('details');
          const incomingDetails = pagination.querySelector('details');
          if (details && incomingDetails) details.replaceWith(incomingDetails);
          this.updateCount();
        }
      } catch (err) {
        if (err.name !== 'AbortError') {
          error = true;
          this.status.textContent = this.dataset.error;
          const details = this.querySelector('details');
          if (details) details.open = true;
        }
      } finally {
        this.busy = false;
        this.grid.removeAttribute('aria-busy');
        if (this.link) {
          this.link.textContent = this.label;
          this.link.removeAttribute('aria-disabled');
        }
        if (focus && firstNew?.isConnected) {
          firstNew.setAttribute('tabindex', '-1');
          firstNew.focus({preventScroll: true});
          firstNew.scrollIntoView({block: 'start', behavior: 'instant'});
        }
        if (!error) this.save();
      }
    }
  }
  if (window.spgBrowseReady) return;
  window.spgBrowseReady = true;
  function scan() {
    for (const [root, instance] of instances) {
      if (!root.isConnected) { instance.disconnect(); instances.delete(root); }
    }
    document.querySelectorAll('[data-spg-pagination]').forEach(root => {
      if (!instances.has(root)) instances.set(root, new CollectionPagination(root));
    });
  }
  new MutationObserver(scan).observe(document.body, {childList: true, subtree: true});
  scan();
})();

